import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";

export const LiveCasinoGridItemInfobarDefaultBox = styled.div`
   display: flex;
   left: 0;
   bottom: 0;
   width: 100%;
   padding: 0.5em 1em;
   background: ${props => hexToRgba(props.theme.components.newLiveCasino.colors.gridItem.infobarBackground, 0.75)};
   position: absolute;

   &::before {
      content: "";
      position: absolute;
      top: -1px;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, transparent, ${props => props.theme.colors.backgroundContrast}, transparent);
   }
   @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      padding: 0.25em;
   }
`;